import React from "react";

export default function OrdersScopeNav({
  scopeTabs,
  activeScope,
  onScopeChange,
}) {
  return (
    <>
      <aside className="hidden lg:block lg:w-56 xl:w-64 shrink-0">
        <div className="sticky top-20 rounded-2xl border border-gray-200 dark:border-neutral-800 bg-white dark:bg-neutral-900 p-5">
          <nav className="space-y-1">
            {scopeTabs.map((tab) => (
              <button
                key={tab.value}
                type="button"
                onClick={() => onScopeChange(tab.value)}
                className={`w-full text-left px-3 py-2 rounded-lg text-sm font-medium transition ${
                  activeScope === tab.value
                    ? "bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300"
                    : "text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-neutral-800"
                }`}
              >
                {tab.label}
              </button>
            ))}
          </nav>
        </div>
      </aside>

      <div className="lg:hidden mb-3">
        <div className="flex items-center gap-2 overflow-x-auto no-scrollbar">
          {scopeTabs.map((tab) => (
            <button
              key={tab.value}
              type="button"
              onClick={() => onScopeChange(tab.value)}
              className={`inline-flex items-center px-2.5 py-1 rounded-full border text-xs font-semibold whitespace-nowrap transition ${
                activeScope === tab.value
                  ? "bg-green-700 border-green-700 text-white dark:bg-green-600 dark:border-green-600"
                  : "bg-white border-gray-300 text-gray-700 dark:bg-neutral-900 dark:border-neutral-700 dark:text-gray-200"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>
    </>
  );
}
